import { produce } from "immer";
import {
  FETCH_FEEDBACK_LIST,
  FETCH_FEEDBACK_LIST_FAILURE,
  FETCH_FEEDBACK_LIST_SUCCESS,
  //
  SUBMIT_FEEDBACK,
  SUBMIT_FEEDBACK_FAILURE,
  SUBMIT_FEEDBACK_SUCCESS,
  //
  UPDATE_FEEDBACK,
  UPDATE_FEEDBACK_FAILURE,
  UPDATE_FEEDBACK_SUCCESS,
  //
  UPDATE_FEEDBACK_STATUS,
  UPDATE_FEEDBACK_STATUS_FAILURE,
  UPDATE_FEEDBACK_STATUS_SUCCESS,
} from "./constants";

export const initialState = {
  // List (shared by "My Feedback" and Review — each page dispatches its own fetch)
  isFetchingList: false,
  list: [],
  statusCounts: {},
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  // Submit
  isSubmitting: false,
  // Update (submitter self-edit)
  isUpdating: false,
  // Update status (product-team triage)
  isUpdatingStatus: false,
};

const FeedbackReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_FEEDBACK_LIST:
        draft.isFetchingList = true;
        break;
      case FETCH_FEEDBACK_LIST_SUCCESS: {
        draft.isFetchingList = false;
        const items = action.payload?.data ?? [];
        const page = action.payload?.current_page ?? 1;
        draft.list = page > 1 ? [...draft.list, ...items] : items;
        draft.statusCounts = action.payload?.status_counts ?? {};
        draft.pagination = {
          current_page: page,
          last_page: action.payload?.last_page ?? 1,
          total: action.payload?.total ?? 0,
        };
        break;
      }
      case FETCH_FEEDBACK_LIST_FAILURE:
        draft.isFetchingList = false;
        draft.list = [];
        break;
      // Submit
      case SUBMIT_FEEDBACK:
        draft.isSubmitting = true;
        break;
      case SUBMIT_FEEDBACK_SUCCESS:
        draft.isSubmitting = false;
        break;
      case SUBMIT_FEEDBACK_FAILURE:
        draft.isSubmitting = false;
        break;
      // Update
      case UPDATE_FEEDBACK:
        draft.isUpdating = true;
        break;
      case UPDATE_FEEDBACK_SUCCESS:
        draft.isUpdating = false;
        break;
      case UPDATE_FEEDBACK_FAILURE:
        draft.isUpdating = false;
        break;
      // Update status
      case UPDATE_FEEDBACK_STATUS:
        draft.isUpdatingStatus = true;
        break;
      case UPDATE_FEEDBACK_STATUS_SUCCESS:
        draft.isUpdatingStatus = false;
        break;
      case UPDATE_FEEDBACK_STATUS_FAILURE:
        draft.isUpdatingStatus = false;
        break;
      default:
        return state;
    }
  });

export default FeedbackReducer;
